import { Form, FormikProps } from "formik";
import { memo } from "react";
import classnames from "classnames";

import { FormikInput } from "components/FormikInput";
import { Button } from "components/Button";
import { FormikTextarea } from "components/FormikTextarea";
import { FormikRadioButtonField } from "components/FormikRadioButtonField";
import { URGENCY_OPTIONS, FIELD_NAMES } from "./AskAQuestion.constanst";
import { ValuesType } from "./AskAQuestion.types";
import { preventEnterSubmit } from "utils";
import config from "config";

interface IProps extends FormikProps<ValuesType> {
  onHide: () => void;
}

function AskAQuestionForm({ status, setFieldValue, values, onHide }: IProps) {
  const hint = config.VERTICAL === 'SPACE'
    ? "This is the place to engage directly with our space experts on any technical or strategic question. For instance, you can ask: “Who are the top players in LEO comms satellite manufacturing, under $100M funding?” or “Has XYZ company built hardware for DoD missions with space heritage?” We’ll get back to you with an answer ASAP!"
    : config.VERTICAL === 'QUANTUM'
      ? "This is the place to engage directly with our quantum experts on any technical or strategic question. For example, you might ask: “Which startups are leading in error-corrected qubit architectures with <$100M in total funding?” or “What is the US State seeing the most quantum funding?” We’ll respond quickly with clear, evidence-backed insights."
      : "Use this place to ask our climate tech experts any detailed technical or market-facing question. For instance, you could ask: “Which pre-Series B companies are advancing DAC (Direct Air Capture) at sub-$300/ton cost targets?” or “Has XYZ firm deployed tech at scale under DOE or EU Green Deal pilot programs?” We’ll respond quickly with clear, evidence-backed insights.";
  return (
    <Form onKeyDown={preventEnterSubmit} className="flex flex-col">
      <div className="">
        <FormikInput
          name={FIELD_NAMES.NAME}
          label="Name"
          placeholder="E.g. John Nollan"
          className="mt-1"
          // require
        />
        <FormikInput
          name={FIELD_NAMES.EMAIL}
          label="Email"
          placeholder="E.g. johnnollan@example.com"
          className="mt-3"
          // require
        />
        <FormikTextarea
          name={FIELD_NAMES.QUESTION}
          label="Your Question"
          placeholder={hint}
          className="pb-4 mt-3"
          style={{ height: "160px" }}
        />

        <FormikRadioButtonField
          inlineLabel="Urgency:"
          name={FIELD_NAMES.URGENCY}
          onChange={(e) => setFieldValue(FIELD_NAMES.URGENCY, e.target.value)}
          options={URGENCY_OPTIONS}
          value={values[FIELD_NAMES.URGENCY]}
          className="pb-2"
          classNames={{
            inlineLabel: "text-[#98A0A6] text-[16px] !font-normal",
            message: "text-red-400",
            inputWrapper: "ml-4 whitespace-nowrap",
            input: "pl-0",
          }}
        />

        <div className="flex items-center xs:flex-row flex-col mt-4 w-[100%]">
          <Button
            customPaddings
            type="button"
            className="flex basis-1 grow justify-center items-center text-center rounded-[4px] border border-primaryBlue text-primaryBlue h-[40px] hover:bg-primaryBlue hover:text-white xs:mt-0 mt-4 px-6"
            onClick={onHide}
          >
            Cancel
          </Button>

          <Button
            disabled={status?.loading}
            type="submit"
            className={classnames(
              "flex basis-1 grow justify-center items-center text-center rounded-[4px] h-[40px] text-white rounded bg-primaryBlue hover:bg-[#3383B0]  xs:ml-6 xs:mt-0 mt-4",
              {
                "bg-gray-300 pointer-events-none": status?.loading,
              }
            )}
          >
            Send
          </Button>
        </div>
      </div>
    </Form>
  );
}

export default memo(AskAQuestionForm);
